<template>
  <div class="queue">
    <div class="queue-max" v-if="!min">
      <div class="queue-header">
        <v-card
          :color="`${workQueueSetting.color[0]}`"
          :style="`border-radius: 4px; border-top: 3px solid ${workQueueSetting.color[1]} !important;`"
        >
          <v-card-title class="pt-2 pb-2 pl-3 pr-2">
            <div class="layout row m-0 p-0 justify-space-between">
              <div class="m-t-2 f-w-500">
                {{ workQueueSetting.title.toUpperCase() }}
                <v-tooltip bottom v-if="assets.tool.isNotEmpty(workQueueSetting.iconItem)">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      icon
                      x-small
                      slot="activator"
                      v-on="on"
                      v-if="isShowElement(workQueueSetting.iconItem.code, assets.dataType.PrivilegeType.EXECUTABLE) && (queueData.count > 0 || (assets.tool.isNotEmpty(queueData.items) && queueData.items.length > 0))"
                      @click="clickBtnHandler(workQueueSetting.status)"
                    >
                      <v-icon>{{ workQueueSetting.iconItem.icon }}</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ workQueueSetting.iconItem.tooltip }}</span>
                </v-tooltip>
              </div>
              <div>
                <v-btn icon x-small @click="min=!min"><v-icon>mdi-chevron-left</v-icon></v-btn>
                <v-chip small outlined>{{ assets.tool.fieldRender(queueData, "{count}") }}</v-chip>
              </div>
            </div>
          </v-card-title>
        </v-card>
      </div>
      <div class="queue-content">
        <vue-perfect-scrollbar class="scroll" :id="eleId" @ps-y-reach-end="scrollHandler">
          <template v-for="(item, index) in queueData.items">
            <arb-application-queue-item
              :key="index"
              :itemData="item"
              :layoutSetting="layoutSetting"
              :loanPhase="loanPhase"
              :color="workQueueSetting.color[0]"
              :queueCode="queueCode"
            ></arb-application-queue-item>
          </template>
        </vue-perfect-scrollbar>
      </div>
      <div class="queue-loading">
        <v-progress-linear
          v-if="queueData.isLoading"
          :color="workQueueSetting.color[0]"
          indeterminate
        ></v-progress-linear>
      </div>
    </div>
    <div class="queue-min" v-else>
      <div class="queue-header">
        <v-card :color="`${workQueueSetting.color[0]}`">
          <v-card-title class="pt-2 pb-2" @click="min=!min">
            <div class="layout row m-0 p-0 justify-space-between">
              <div class="m-t-2 f-w-500">{{ workQueueSetting.title.toUpperCase() }}
              </div>
              <div style="float: left">
                <v-btn class="m-l-30 m-r-10" icon x-small @click="min=!min"><v-icon>keyboard_arrow_up</v-icon></v-btn>
                <v-chip small outlined>{{ assets.tool.fieldRender(queueData, "{count}") }}</v-chip>
              </div>
            </div>
          </v-card-title>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { Tool, DataType, Authentication } from '@/util/index'
const $tool = new Tool()
export default {
  name: 'arb-application-queue',
  props: {
    workQueueSetting: Object,
    layoutSetting: Object,
    queueData: Object,
    loanPhase: Number,
    queueCode: String
  },
  data () {
    return {
      assets: {
        tool: $tool,
        dataType: DataType
      },
      min: true
    }
  },
  created () {
    this.min = (this.queueData.count === 0 || $tool.isEmpty(this.queueData.count))
  },
  computed: {
    eleId () {
      return 'queue' + this._uid
    }
  },
  watch: {
    'queueData.count': function (val) {
      this.min = val <= 0
    }
  },
  methods: {
    clickBtnHandler (loanStatus) {
      switch (loanStatus) {
        case DataType.LoanStatus.TRIBE_REVIEW.value:
          this.$eventBus.$emit('batchApproveHandler')
          break
        case DataType.LoanStatus.GOOD_STANDING_PAID_OFF.value:
        case DataType.LoanStatus.PAID_OFF.value:
        case DataType.LoanStatus.WARNING_PAID_OFF.value:
        case DataType.LoanStatus.IN_HOUSE_REPLAN_PAID_OFF.value:
        case DataType.LoanStatus.IN_HOUSE_SETTLEMENT_PAID_OFF.value:
          this.$eventBus.$emit('exportPaidOffHandler', loanStatus)
          break
        case DataType.LoanStatus.UNDERWRITER_REVIEW.value:
          this.$eventBus.$emit('exportUnderWriterHandler', loanStatus)
          break
        default:
          break
      }
    },
    async scrollHandler () {
      this.$emit('scrollHandler', this.workQueueSetting)
    },
    isShowElement (code, value) {
      let result = false
      const authorization = this.store.getters.getAuthorization
      if ($tool.isNotEmpty(authorization)) {
        const privileges = authorization.privileges
        result = Authentication.matchElementPrivilege(privileges, code, value)
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.queue + .queue {
  margin-left: 10px;
}
.queue {
  height: calc(100vh - 240px) !important;
  .queue-max {
    max-width: 320px !important;
    min-width: 320px !important;
    .queue-header {
      margin-bottom: 20px;
    }
    .scroll {
      height: calc(100vh - 300px);
      width: 103%;
    }
    .queue-loading{
      height: 5px;
    }
  }
  .queue-min {
    max-width: 40px !important;
    min-width: 40px !important;
    transform: rotate(90deg);
    .queue-header {
      width: calc(100vh - 245px) !important;
      letter-spacing: .5em;
    }
  }
}
</style>

<style lang="sass" scoped>
.v-card
  &__title
    font-size: unset
    line-height: unset
</style>
<style>
.queue-header .v-chip {
  padding: 0 6px !important;
}
</style>
